import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppConfig } from '@app/core/app.config';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import {
  CreateDatagridVisualisationNameReset
} from '@app/shared/store/reducers/create-datagrid-visualisation-name.actions';
import { ExtraValidators } from '@app/shared/validators/extra-validators.module';
import { Store } from '@ngrx/store';
import ApiService from '@services/api.service';
import { AppManager } from '@services/managers/app.manager';

@Component({
  templateUrl: './create-datagrid-visualisation-modal.component.html',
  standalone: false
})
export class CreateDatagridVisualisationModalComponent implements OnInit, OnDestroy {
  private readonly apiService = inject(ApiService);
  private readonly fb = inject(FormBuilder);
  private readonly store = inject<Store<any>>(Store);
  private readonly appManager = inject(AppManager);
  protected readonly appConfig = inject(AppConfig);
  private readonly data = inject(MAT_DIALOG_DATA);

  public visualisationForm: FormGroup<{ name: FormControl<string> }>;

  /**
   * Initializes the form. The name must be unique among all the visualisations of the datagrid in the organization,
   * whoever they belong to, as checked by the API on creation.
   * @return void
   */
  public ngOnInit(): void {
    this.visualisationForm = this.fb.group({
      name: this.fb.control('', Validators.compose([
        Validators.required,
        Validators.maxLength(this.appConfig.NAME_MAX_LENGTH)
      ]))
    });
    this.visualisationForm.controls.name.setAsyncValidators(
      ExtraValidators.isValueTaken(this.apiService, EntityTypeEnum.DATAGRID_VISUALISATION, 'name', '', {
        datagrid: this.data.datagrid,
        organizationId: this.appManager.currentOrganization.id
      }, {
        store: this.store,
        fieldName: 'createDatagridVisualisationName'
      })
    );
  }

  public ngOnDestroy(): void {
    this.store.dispatch(new CreateDatagridVisualisationNameReset({currentValue: '', originalValue: ''}));
  }

  public getGeneratedObject(): any {
    return {
      visualisationName: this.visualisationForm.controls.name.value
    };
  }

}
